import { render, staticRenderFns } from "./IndicatorsAdd.vue?vue&type=template&id=077cbe82&"
import script from "./IndicatorsAdd.vue?vue&type=script&lang=ts&"
export * from "./IndicatorsAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports